import React, { useEffect, useRef, useCallback } from "react";
import Search from "../../../assets/yfs-label-retrieve/Plus magnify.svg";

import "./index.css";

const OverviewMagnify = ({ children, setIsZoomed, isZoomed, toggleZoom }) => {
  const modalRef = useRef(null);

  const handleOutsideClick = useCallback(
    (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsZoomed(false);
      }
    },
    [setIsZoomed]
  );

  useEffect(() => {
    if (isZoomed) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isZoomed, setIsZoomed, handleOutsideClick]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isZoomed) {
        setIsZoomed(false);
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isZoomed, setIsZoomed]);

  useEffect(() => {
    if (isZoomed) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isZoomed]);

  return (
    <div className="viewer-container">
      {/* Preview content */}
      <div className="content-container">
        <button onClick={toggleZoom} className="zoom-in-button">
          <img src={Search} alt="Zoom In Icon" />
        </button>
        <div className="preview-container">
          <div>{children}</div>
        </div>
      </div>

      {/* Modal overlay */}
      {isZoomed && (
        <div
          className={`modal-overlay-prod ${isZoomed ? "visible" : ""}`}
          style={{ backdropFilter: "blur(15px)" }}
        >
          <div className="modal-content-prod" ref={modalRef}>
            {children}
          </div>
        </div>
      )}
    </div>
  );
};

export default OverviewMagnify;
